import { AppMain, Navbar, TagsView } from './components';
import AppSidebar from './components/Sidebar/index.vue';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';
const platformEnv = process.env.VUE_APP_PLATFORM;
export default {
  name: 'LayoutIndex',
  components: {
    AppMain,
    Navbar,
    AppSidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  data() {
    return {
      platformEnv
    };
  },
  computed: {
    ...mapState({
      // 勿用名 sidebar：与侧栏组件/标签解析冲突时会导致子组件不渲染（DOM 仅 <!---->）
      appSidebar: state => state.app.sidebar,
      device: state => state.app.device,
      full: state => state.app.full,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.appSidebar.opened,
        openSidebar: this.appSidebar.opened,
        withoutAnimation: this.appSidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    hideSidebarByRoute() {
      return this.$route.path === '/user-business-voucher';
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    }
  }
};